export default __webpack_public_path__ + "static/media/2b923433-7997-47fa-b6ee-b1915fcf811f.ae0bafa5.jpg";